export default __webpack_public_path__ + "static/video-carousel-preview-092acf5e071b5d5f7e9cc6d97250d74e.png";